import { useUnit } from 'effector-react'

import { ErrorBoundary } from '@/components/ui/ErrorBoundary/ErrorBoundary'
import { $fanId } from '@/models/chattingUI/chats/chats.ts'

import { Chat } from './Chat'

interface Props {
  isFanInfoVisible: boolean
  toggleFanInfo: () => void
}

export const ChatWindow = ({ isFanInfoVisible, toggleFanInfo }: Props) => {
  const fanId = useUnit($fanId)

  if (!fanId) {
    return (
      <div className="flex h-full w-full flex-1 items-center justify-center">
        <p className="mt-4">Please select a chat to message</p>
      </div>
    )
  }

  return (
    <ErrorBoundary
      fallbackTemplate="module"
      boundaryName="ChatWindow"
      resetKeys={[fanId]}
    >
      <Chat
        isFanInfoVisible={isFanInfoVisible}
        toggleFanInfo={toggleFanInfo}
      />
    </ErrorBoundary>
  )
}
